import React, { useContext, useEffect, useState, } from 'react';
import "./AcademicCalendar.scss";
import DynamicDownloadBtnSection from '../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection';
import { AppContext } from '../../context/AppContext';
import { toast } from 'react-toastify';
import axios from 'axios';

const AcademicCalendar = () => {

    const [allAcademicCalendar, setAllAcademicCalendar] = useState([]);
    const { backendUrl } = useContext(AppContext);
     let errorShown = false;
    
    async function fetchAllAcademicCalendar() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllAcademicCalendar`);
            if (data.success) {
                setAllAcademicCalendar(data || []);
            }
            errorShown = false;  
        } catch (error) {
            if (errorShown) return;
            errorShown = true;
             if (error.response && error.response.status === 503) {
                            toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                        }
                        else if (!navigator.onLine) {
                            toast.error("🚫 No internet connection. Please check your network.");
                        }
            
                        else if (error.request && !error.response) {
                            toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                        }
                        else 
                        {
                            console.error("Unexpected error:", error);
                            toast.error("Something went wrong.");
                        }
        }
    }

    useEffect(() => {
        fetchAllAcademicCalendar();
    }, [])

    const content = allAcademicCalendar?.reports
        ?.filter(item => item.isActive)
        .map(item => ({
            filename: item.filename,
            data: item.data,
            contentType: item.contentType,
        })) || [];

    return (
        <section className="academicCalendarMainContainer main-content">
            <header className="academicCalendarHeader">
                <h2>Academic Calendar</h2>
            </header>
            <DynamicDownloadBtnSection
                items={content}
                yearFontSize={1.2}
                titleFontSize={1.2}
            />
        </section>
    );
}

export default AcademicCalendar;
